import {Component, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {AppSnackbarData} from '../../../models/modal/snackbar/app-snackbar-data.model';
import {AppSnackbarModal} from '../../../models/modal/snackbar/app-snackbar-modal.model';
import {ModalService} from '../../../services/modal/modal.service';
import {ButtonComponent} from '../../buttons/button/button.component';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {AppSnackbarCloseReasonEnum} from '../../../enums/modal/app-snackbar-close-reason.enum';
import {APP_MODAL_REF} from '../../../constants/modal/app-modal-ref.constant';
import {StringUtils} from '../../../util/string-utils/string.util';

@Component({
    selector: 'app-snackbar-modal',
    imports: [
        TranslatePipe,
        ButtonComponent
    ],
    templateUrl: './snackbar-modal.component.html'
})
export class SnackbarModalComponent {
    public readonly modalData: AppSnackbarData;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly qaTag: string;
    protected readonly timeoutInSeconds: number;
    protected readonly hasTimeout: boolean;
    private readonly modalRef = inject<AppSnackbarModal>(APP_MODAL_REF);
    private readonly modalService = inject(ModalService);

    public constructor() {
        this.qaTag = StringUtils.transformToKebabCase(this.modalRef.qaTag);
        this.modalData = this.modalRef.modalData;
        this.hasTimeout = !!this.modalData.timeoutInMS;
        this.timeoutInSeconds = ((this.modalData.timeoutInMS ?? 0) / 1000);
    }

    protected dismissWithAction(): void {
        this.modalService.closeModal(this.modalRef, AppSnackbarCloseReasonEnum.Action);
    }
}
